import React from "react"
import {
  Formik,
  Form as FormikForm,
  Field,
  //useFormikContext
} from "formik"
import * as Yup from "yup"
import * as ErrorMessage from "../../common/errorMessage"
import * as Alert from "../../services/sweetalertService"
import * as Constants from "../../common/constants"
import * as Regex from "../../common/regex"
import * as CommonFunction from "../../common/function"

import FormTextbox from "../shared/formTextbox"
import FormFieldDisableAutoComplete from "../shared/formFieldDisableAutoComplete"
import FormDatePickerTextBox from "../shared/formDatePickerTextBox"
import FormTimeTextBox from "../shared/formTimeTextBox"
import FormRadioButton from "../shared/formRadioButton"
import FormAmountTextBox from "../shared/formAmountTextBox"
import FormSectionTitle from "../shared/formSectionTitle"

import { useDispatch, batch } from "react-redux"
import {
  controlEditBenefit,
  updateValidFormData,
  updateClickedNext,
  pageIncrement,
  updateFormIsValid,
  moveToPage,
  controlDeclaration,
} from "../../redux/actions"
import { Row, Col } from "react-bootstrap"
import EditBenefitImg from "../../content/img/editBenefit.png"
import { parse, format } from "date-fns"

const LossDamageDetails = ({ claimData, uiData }) => {
  const {
    pageNumber,
    editBenefits,
    clickedNext,
    proofDocuments,
    claimUploadListModel,
    hideHeaderFooter,
    policyStartDate,
    policyEndDate,
  } = uiData
  const formName = Constants.lossDamageDetailsFormName
  const dispatch = useDispatch()
  const formRef = React.useRef()

  // const todayDate = format(new Date(), `d${Constants.sep}M${Constants.sep}yyyy`)
  // const firstDayOfMonth = format(new Date(new Date().getFullYear(), new Date().getMonth(), 1), `d${Constants.sep}M${Constants.sep}yyyy`)

  const lossDamageDetailsSchema = Yup.object().shape({
    // timeLastSeen: Yup.string().when("dateLastSeen", {
    //   is: val => val !== undefined,
    //   then: Yup.string()
    //     .required(ErrorMessage.timeLastSeen)
    //     .test("timeLastSeen", ErrorMessage.futureTimeErrorMsg, value => {
    //       return CommonFunction.notFutureDatime(
    //         formRef.current.values.dateLastSeen,
    //         value
    //       )
    //     })
    //     .matches(Regex.timepattern, ErrorMessage.timeLastSeen),
    // }),
    dateDiscovery: Yup.date().required(ErrorMessage.dateDiscovery).test(
      "dateDiscovery",
      ErrorMessage.dateFirstDiscoveryEarlierThanLastSeenDate,
      value => {
        if (formRef.current.values.dateLastSeen && value) {
          return CommonFunction.isAfterDateTime(
            formRef.current.values.dateLastSeen,
            "00:00",
            value,
            "00:00"
          )
        } else {
          return true
        }
      }
    ),

    lossDetail: Yup.string().min(2, ErrorMessage.lossDetail).required(ErrorMessage.lossDetail),

    // ownerName: Yup.string().when("soleOwner", {
    //   is: val => val === false,
    //   then: Yup.string().required(ErrorMessage.ownerName),
    // }),
    // ownerAddress: Yup.string().when("soleOwner", {
    //   is: val => val === false,
    //   then: Yup.string().required(ErrorMessage.ownerAddress),
    // }),
    // financeName: Yup.string().when("onLoan", {
    //   is: val => val === true,
    //   then: Yup.string().required(ErrorMessage.financeName),
    // }),
    otherInsuranceName: Yup.string().when("otherInsurance", {
      is: val => val === true,
      then: Yup.string().min(2, ErrorMessage.otherInsuranceName).required(ErrorMessage.otherInsuranceName),
    }),
    // claimInsuranceName: Yup.string().when(
    //   ["claimOtherInsurance", "otherInsurance"],
    //   {
    //     is: true,
    //     then: Yup.string().required(ErrorMessage.claimInsuranceName),
    //   }
    // ),
    // claimInsuranceDate: Yup.string().when(
    //   ["claimOtherInsurance", "otherInsurance"],
    //   {
    //     is: true,
    //     then: Yup.string().required(ErrorMessage.claimInsuranceDate),
    //   }
    // ),
    // claimInsuranceDetail: Yup.string().when(
    //   ["claimOtherInsurance", "otherInsurance"],
    //   {
    //     is: true,
    //     then: Yup.string().required(ErrorMessage.claimInsuranceDetail),
    //   }
    // ),
    // claimInsuranceAmount: Yup.number().when(
    //   ["claimOtherInsurance", "otherInsurance"],
    //   {
    //     is: true,
    //     then: Yup.number()
    //       .transform(value => (isNaN(value) ? undefined : value))
    //       .min(1, ErrorMessage.claimInsuranceAmount),
    //   }
    // ),
  })

  const handleEditBenefit = () => {
    dispatch(controlEditBenefit(formName))
  }

  return (
    <Formik
      initialValues={Object.assign({}, claimData["claimFireDetail"])}
      enableReinitialize={true}
      validationSchema={lossDamageDetailsSchema}
      validateOnMount={true}
      innerRef={formRef}
      onSubmit={(values, actions) => {}}
    >
      {({ handleSubmit, isValid, values, errors }) => (
        <div>
          <Row
            className={
              "col-xs-12 bigScreenNarrowing form-group ReviewChoosedDetailDiv " +
              (pageNumber === Constants.reviewPageNumber &&
              !editBenefits[formName]
                ? ""
                : "hide")
            }
          >
            <div className="col-md-10 col-8 summaryBenefit">
              <b> {formName} </b>
            </div>
            <div className="col-md-2 col-4 row noMarginLeftRightSmallScreen">
              <div
                className="col-12 pr-0"
                onClick={() => {
                  handleEditBenefit()
                }}
                onKeyDown={() => {
                  handleEditBenefit()
                }}
                tabIndex="0"
                role="button"
              >
                <img className="editBtn" src={EditBenefitImg} alt=""></img>
              </div>
            </div>
          </Row>
          <FormikForm onSubmit={handleSubmit}>
            <Row
              className={
                pageNumber === Constants.lossDamageDetailsPageNumber ||
                (pageNumber === Constants.reviewPageNumber &&
                  editBenefits[formName])
                  ? ""
                  : "hide"
              }
            >
              <div
                className={
                  "title text-center " +
                  (pageNumber === Constants.lossDamageDetailsPageNumber
                    ? ""
                    : "hide") +
                  " " +
                  (hideHeaderFooter ? "MarginTop15" : "MarginTop75")
                }
              >
                Submit online HDB Fire claim
              </div>
              <Row
                className={
                  "containerBody " +
                  (pageNumber === Constants.reviewPageNumber
                    ? "blueBG summaryContainerBody mb-4 "
                    : "marginTop3x")
                }
              >
                <Col
                  xs={{ span: 12, offset: 0 }}
                  md={{ span: 12, offset: 0 }}
                  className="formContainer"
                >
                  <div
                    className={
                      "horizontal-align marginBottom1x " +
                      (pageNumber === Constants.lossDamageDetailsPageNumber ||
                      (pageNumber === Constants.reviewPageNumber &&
                        editBenefits[formName])
                        ? ""
                        : "hide")
                    }
                  >
                    <Col xs={12} md={12}>
                      <div
                        className={
                          "titleText " +
                          (pageNumber === Constants.reviewPageNumber
                            ? "hide"
                            : "")
                        }
                      >
                        {formName}
                      </div>
                    </Col>
                  </div>
                  {
                    <Row
                      className={
                        "form-group " + (editBenefits[formName] ? "" : "hide")
                      }
                    >
                      <div className="col-md-9 col-7 textforinput marginTop10px benefitEditTitle">
                        <p>{formName}</p>
                      </div>
                      <div className="col-md-3 col-5 marginTop10px">
                        <div
                          className="cursorPointer"
                          role="button"
                          tabIndex="0"
                          onClick={() => dispatch(controlEditBenefit(formName))}
                          onKeyDown={() =>
                            dispatch(controlEditBenefit(formName))
                          }
                        >
                          <p className="doneEdit">DONE EDIT</p>
                        </div>
                      </div>
                    </Row>
                  }
                  {/* Fake fields are a workaround for chrome autofill getting the wrong fields */}
                  <Field
                    textDesc={"Disable Auto Complete"}
                    name="disableAutoComplete"
                    component={FormFieldDisableAutoComplete}
                  />
                  <Field
                    textDesc="Date property was last seen (for loss only)"
                    name="dateLastSeen"
                    component={FormDatePickerTextBox}
                    disableBefore={policyStartDate}
                    disableAfter={policyEndDate}
                    allowFutureDate={true}
                  />
                  {/* <Field
                    textDesc="Date property was last seen (for loss only)"
                    name="timeLastSeen"
                    component={FormTimeTextBox}
                  /> */}

                  <Field
                    textDesc="Date of first discovery of loss or damage"
                    name="dateDiscovery"
                    component={FormDatePickerTextBox}
                    disableBefore={policyStartDate}
                    disableAfter={policyEndDate}
                    allowFutureDate={true}
                    // asterisk={true}
                  />

                  <Field
                    textDesc={"State full circumstances of loss or damage"}
                    maxLength={4000}
                    name="lossDetail"
                    component={FormTextbox}
                    toUpperCase={false}
                    // asterisk={true}
                  />

                  <Field
                    textDesc={
                      "Are you the sole owner of the property lost or damaged?"
                    }
                    name="soleOwner"
                    component={FormRadioButton}
                  />
                  {/* {!values.soleOwner && (
                    <>
                      <Field
                        textDesc={"Disable Auto Complete"}
                        name="disableAutoComplete2"
                        component={FormFieldDisableAutoComplete}
                      />
                      <Field
                        textDesc={"Name of the owner"}
                        maxLength={100}
                        name="ownerName"
                        component={FormTextbox}
                        toUpperCase={false}
                      />
                      <Field
                        textDesc={"Address of the owner"}
                        maxLength={100}
                        name="ownerAddress"
                        component={FormTextbox}
                        toUpperCase={false}
                      />
                    </>
                  )} */}

                  <Field
                    textDesc={
                      "Is the property under HDB Loan? "
                    }
                    name="onLoan"
                    component={FormRadioButton}
                  />
                  {/* {values.onLoan && (
                    <>
                      <Field
                        textDesc={"Name of finance or lending company"}
                        maxLength={100}
                        name="financeName"
                        component={FormTextbox}
                        toUpperCase={false}
                      />
                      <Field
                        textDesc={"Address of finance or lending company"}
                        maxLength={100}
                        name="financeAddress"
                        component={FormTextbox}
                        toUpperCase={false}
                      />
                    </>
                  )} */}

                  <Field
                    textDesc={
                      "Are there any other insurance policies covering the same property?"
                    }
                    name="otherInsurance"
                    component={FormRadioButton}
                  />
                  {values.otherInsurance && (
                    <>
                      <Field
                        textDesc={"Name of other Insurer"}
                        maxLength={100}
                        name="otherInsuranceName"
                        component={FormTextbox}
                        toUpperCase={false}
                      />
                      {/* <Field
                        textDesc={"Address of insurance company"}
                        maxLength={100}
                        name="otherInsuranceAddress"
                        component={FormTextbox}
                        toUpperCase={false}
                      />
                      <Field
                        textDesc={"Type of insurance"}
                        maxLength={100}
                        name="otherInsuranceType"
                        component={FormTextbox}
                        toUpperCase={false}
                      />
                      <Field
                        textDesc={"Policy Number"}
                        maxLength={50}
                        name="otherInsuranceRefNo"
                        component={FormTextbox}
                        toUpperCase={false}
                      /> */}
                      <Field
                        textDesc={"Sum Assured"}
                        maxLength={10}
                        name="otherInsuranceSumInsured"
                        component={FormAmountTextBox}
                        placeholder={""}
                      />
                    </>
                  )}

                  <Field
                    textDesc={
                      "Have you ever sustained loss of a similar nature?"
                    }
                    name="lossBefore"
                    component={FormRadioButton}
                  />

                  {/* {values.otherInsurance && (
                    <>
                      <Field
                        textDesc={"Disable Auto Complete"}
                        name="disableAutoComplete3"
                        component={FormFieldDisableAutoComplete}
                      />
                      <Field
                        textDesc={
                          "Was a claim made upon any insurance company?"
                        }
                        name="claimOtherInsurance"
                        component={FormRadioButton}
                      />
                      {values.claimOtherInsurance && (
                        <>
                          <Field
                            textDesc={"Name"}
                            maxLength={100}
                            name="claimInsuranceName"
                            component={FormTextbox}
                            toUpperCase={false}
                          />
                          <Field
                            textDesc="Date"
                            name="claimInsuranceDate"
                            component={FormDatePickerTextBox}
                          />
                          <Field
                            textDesc={"Nature of loss"}
                            maxLength={4000}
                            name="claimInsuranceDetail"
                            component={FormTextbox}
                            toUpperCase={false}
                          />
                          <Field
                            textDesc={"Sum Insured (SGD)"}
                            maxLength={10}
                            name="claimInsuranceAmount"
                            component={FormAmountTextBox}
                            placeholder={""}
                          />
                        </>
                      )}
                    </>
                  )} */}

                  <br />
                </Col>
              </Row>
            </Row>
            <HandleFormValidation
              thisPageClickedNext={
                clickedNext[Constants.lossDamageDetailsPageNumber]
              }
              reviewPageClickedNext={clickedNext[Constants.reviewPageNumber]}
              formRef={formRef}
              values={values}
              thisPageNumber={Constants.lossDamageDetailsPageNumber}
              dispatch={dispatch}
              formName={formName}
              proofDocuments={proofDocuments}
              claimUploadListModel={claimUploadListModel}
            />
          </FormikForm>
        </div>
      )}
    </Formik>
  )
}

const HandleFormValidation = ({
  thisPageClickedNext,
  reviewPageClickedNext,
  formRef,
  values,
  thisPageNumber,
  dispatch,
  formName,
  proofDocuments,
  claimUploadListModel,
}) => {
  React.useEffect(() => {
    if (thisPageClickedNext || reviewPageClickedNext) {
      formRef.current.validateForm().then(errors => {
        // console.log(errors)
        batch(() => {
          if (Object.entries(errors).length === 0) {
            // console.log("PASS")
            dispatch(updateValidFormData("claimFireDetail", values))

            if (thisPageClickedNext) {
                // dispatch(pageIncrement())
                dispatch(controlDeclaration())
            } else {
              dispatch(updateFormIsValid(formName, true))
            }
          } else {
            // console.log("FAIL")
            if (thisPageClickedNext) {
              Alert.missingInfoAlert()
            } else {
              dispatch(updateFormIsValid(formName, false))
            }
            formRef.current.submitForm() // Set touched to all fields
          }

          dispatch(updateClickedNext(thisPageNumber, false))
        })
      })
    }
  }, [
    formRef,
    values,
    thisPageNumber,
    dispatch,
    thisPageClickedNext,
    reviewPageClickedNext,
    formName,
  ])

  const checkDocumentUploaded = (documentId, claimUploadListModel) => {
    var hasExists = claimUploadListModel.filter(doc => {
      return doc.documentId === documentId
    })

    return hasExists.length > 0
  }

  return null
}
export default LossDamageDetails
